module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8AQMAAACq8Y2NAAAABlBMVEXOEST////862ZCAAAAGElEQVQoz2P4DwIfGEYpKlFDBYxGFVUpAFx0OD8RYqY2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gb-eng.png
// module id = DRCh
// module chunks = 0